import { UnsavedChangesProtection } from 'v5/patterns/forms/unsaved-changes/UnsavedChangesProtection';
import { Dialog, DialogContentHeadless } from 'v5/design-system/Dialog';
import type { EnterpriseTeam } from 'v5/api/enterprise/enterprise.api';
import { MountElementProps } from 'v5/messages/mount-element';
import { WithServices } from 'v5/platform/ts/services';
import { WithToastService } from 'v5/services/front/ToastService/ToastService';
import { WithUploadService } from 'v5/services/io/UploadService/UploadService';
import {
  EnterpriseTeamDialogContent,
  EnterpriseTeamFormData
} from './EnterpriseTeamDialogContent';

export type EditEnterpriseTeamDialogProps = MountElementProps &
  WithServices<[WithUploadService, WithToastService]> & {
    team: EnterpriseTeam;
    onSubmit?: (data: EnterpriseTeamFormData) => Promise<void> | void;
  };

export function EditEnterpriseTeamDialog({
  open,
  onOpenChange,
  close,
  team,
  onSubmit,
  services
}: EditEnterpriseTeamDialogProps) {
  return (
    <UnsavedChangesProtection
      open={open}
      onOpenChange={onOpenChange}
      beforeUnloadMessage="You have unsaved changes!"
    >
      {dialogProps => (
        <Dialog {...dialogProps}>
          <DialogContentHeadless className="max-w-150">
            <EnterpriseTeamDialogContent
              team={team}
              open={dialogProps.open}
              services={services}
              onSubmit={async data => {
                await onSubmit?.(data);
                close();
              }}
            />
          </DialogContentHeadless>
        </Dialog>
      )}
    </UnsavedChangesProtection>
  );
}
